export default __webpack_public_path__ + "static/media/WorkingRemotely.png.webp";